var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7302 24.1621C19.3576 24.1621 24.7302 18.7838 24.7302 12.1494C24.7302 5.51499 19.3576 0.136719 12.7302 0.136719C6.10281 0.136719 0.730225 5.51499 0.730225 12.1494C0.730225 18.7838 6.10281 24.1621 12.7302 24.1621Z",
    fill: "#EF0027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1791 7.57858L6.3551 5.58447L12.0514 19.9336L19.9886 10.2529L17.1791 7.57858ZM17.0051 8.45701L18.6611 10.0329L14.1326 10.8535L17.0051 8.45701ZM13.1486 10.6891L8.3756 6.72643L16.1771 8.16345L13.1486 10.6891ZM12.8089 11.3904L12.0304 17.8322L7.8341 7.25874L12.8089 11.3896V11.3904ZM13.5289 11.732L18.5441 10.8235L12.7916 17.8382L13.5289 11.732Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_4046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0254,
    fill: "white",
    transform: "translate(0.730225 0.136719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.c0834c3d23919938e2aac113feb479be.svg";
export { ForwardRef as ReactComponent };